<template>
  <button 
    :aria-label="isSaved ? 'Saved' : 'Add to Saved List'"
    tabindex="0"
    data-jest="save-toggle-wrapper"
    class="sj-save-toggle-wrapper"
    @click="toggleSaved"
    @keydown.space.prevent="toggleSaved"
  >
    <sjwc-icon
      :name="iconName"
      aria-hidden="true"
      class="sj-save-toggle"
    />
  </button>
</template>

<script setup>
import { ref, computed } from 'vue';

const isSaved = ref(false);
const loading = ref(false);

const iconName = computed(() => {
  if (loading.value) {
    return 'fa fa-spinner fa-spin';
  }
  return isSaved.value ? 'fa fa-bookmark' : 'fa fa-bookmark-o';
});

const toggleSaved = () => {
  isSaved.value = !isSaved.value;
  // handle API requests here
};
</script>